import { ThemeType } from '@/enums/themeType';
import {
  LiveBetsStateProps,
  LiveBetActions,
  AddBetPayload,
  LiveBetStatePayload,
} from './props';

let initialState: LiveBetsStateProps = {
  bets: [],
};

export default function liveBetsReducer(
  state: LiveBetsStateProps = initialState,
  action: LiveBetStatePayload,
): LiveBetsStateProps {
  switch (action.type) {
    case LiveBetActions.AddBet: {
      const bets =
        state.bets.length === 20
          ? state.bets.slice(1).concat(action.payload)
          : state.bets.concat(action.payload);

      return { ...state, bets };
    }

    default:
      return state;
  }
}
